<template>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button class="button_back" @click="goBack">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
       <ion-title>This shift is no longer available.</ion-title>
    </ion-toolbar>
</template>
  
<script setup>
import { useRouter } from "vue-router";

const $router = useRouter();
const goBack = () => {
  $router.push({
    name: "home",
  });
};
</script>